import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import { UserNotification_NotificationFragmentDoc } from '../../../../../../config/user/user-notifications/UserNotifications.graphql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserNotificationsScreen_NotificationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.User_Notifications_Bool_Exp>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UserNotificationsScreen_NotificationsQuery = { user_notifications: Array<{ created_at: string, creator_id: string, event_id?: string | null, read_at?: string | null, updated_at: string, id: string, is_strong: boolean, type: string, payload: any }> };


export const UserNotificationsScreen_NotificationsDocument = gql`
    query UserNotificationsScreen_Notifications($where: user_notifications_bool_exp, $limit: Int) {
  user_notifications(where: $where, limit: $limit) {
    ...UserNotification_notification
  }
}
    ${UserNotification_NotificationFragmentDoc}`;

export function useUserNotificationsScreen_NotificationsQuery(options?: Omit<Urql.UseQueryArgs<UserNotificationsScreen_NotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserNotificationsScreen_NotificationsQuery, UserNotificationsScreen_NotificationsQueryVariables>({ query: UserNotificationsScreen_NotificationsDocument, ...options });
};